import { render, staticRenderFns } from "./ipregion.vue?vue&type=template&id=52b706f8&"
import script from "./ipregion.vue?vue&type=script&lang=js&"
export * from "./ipregion.vue?vue&type=script&lang=js&"
import style0 from "./ipregion.vue?vue&type=style&index=0&id=52b706f8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports